$(function () {
  'use strict';
  var $editor = $('#temporary-image-user-dialog');

  $(function () {
    var userAgent = window.navigator.userAgent.toLowerCase();
    var $progress = $editor.find('.progress .bar');
    var $preview = $editor.find('.temporary-image-preview > img');
    var $message = $editor.find('.message > p');
    var $submit = $editor.find('button.submit');

    $editor.on("dialogopen", function (event, ui) {
      $submit.hide();
    });

    $editor.on("dialogclose", function (event, ui) {
      $preview.cropper('destroy');
    });

    // Cropper の初期化が完了したら submit ボタンを有効にする。
    $preview.on('built.cropper', function() {
      $message.html('範囲を選択して登録してください。');
      $submit.show();
      // Androidの場合は、クロッパーを起動中にスワイプリフレッシュを停止する
      if (userAgent.match(/^TUNAG-Android\/(\d)\.(\d)\.(\d)\.(\d)/i)) {
        Android.disableSwipeRefresh();
      }
    });

    // ファイルアップロード
    $editor.find('input[type=file].upload').fileupload({
      dataType: 'json',
      send: function (e, date) {
        $submit.hide();
        $preview.cropper('destroy');
        $message.html('画像をアップロードしています。');
        $progress.css('width', '0%');
        $progress.show();
      },
      done: function (e, data) {
        $progress.hide();
        $.each(data.result.files, function (index, file) {
          if (file.error) {
            $message.html(file.error);
          } else {
            // jQuery の data 属性の キャシュ 対策 のため setAttribute を用いる。
            // https://w3g.jp/blog/jquery-data-attr-cache
            document.getElementById('temporary-image').setAttribute('src', file.url);
            document.getElementById('temporary-image').setAttribute('data-filename', file.name);

            var aspect_rate = $preview.data('aspect-rate');
            $preview.cropper({autoCropArea: 1.0, aspectRatio: aspect_rate, zoomable: false, viewMode: 0, minCropBoxWidth: 32, minCropBoxHeight: 32});
          }
        });
      },
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        //console.log('progress:' + progress + '%');
        $progress.css('width', progress + '%');
      }
    });

    // 登録ボタン
    $submit.on('click', function () {
      var $form = $editor.find('form.submit');
      var canvasData = $preview.cropper('getCanvasData');
      var cropBoxData = $preview.cropper('getCropBoxData');
      // jQuery の data 属性の キャシュ 対策 のため getAttribute を用いる。
      var filename = document.getElementById('temporary-image').getAttribute('data-filename');
      // Androidの場合は、クロッパーを起動中にスワイプリフレッシュを停止する
      if (userAgent.match(/^TUNAG-Android\/(\d)\.(\d)\.(\d)\.(\d)/i)) {
        Android.enableSwipeRefresh();
      }

      if ($form.data('async')) {
        var formData = new FormData($form[0]);
        formData.append("temporary_image[canvas]", JSON.stringify(canvasData));
        formData.append("temporary_image[cropped]", JSON.stringify(cropBoxData));
        formData.append("temporary_image[filename]", filename);

        $.ajax('/temporary_images/' + filename + '/submit', {
            type: 'post',
            processData: false,
            contentType: false,
            data: formData,
            dataType: "json",
            beforeSend: function () {
              $submit.prop("disabled", true);
            },
            success: function (data) {
              // $preview.cropper('destroy');
              // $submit.hide();
              // $message.html('画像が設定されました。');
              // $preview.attr("src", data.url);
              $editor.dialog("close");
              toastr.success('画像が設定されました。');
              // setTimeout(function(){location.reload()},3000);
            },
            error: function (data) {
              $message.html(data.message);
            }
          }
        );
      } else {
        $form.attr('action', '/temporary_images/' + filename + '/submit');
        $('<input>').attr('type', 'hidden').attr('name', 'temporary_image[canvas]').attr('value', JSON.stringify(canvasData)).appendTo($form);
        $('<input>').attr('type', 'hidden').attr('name', 'temporary_image[cropped]').attr('value', JSON.stringify(cropBoxData)).appendTo($form);
        $form.submit();
      }
    });

  });
});